<template>
  <div
    class="kk-option-item-label"
    :class="[
      size ? `kk-option-item-label--${size}` : '',
      isDisabled ? 'kk-option-item-label--disabled' : '',
    ]"
  >
    {{ label }}
    <span v-if="isRequired">*</span>
  </div>
</template>

<script>
export default {
  name: 'KkOptionItemLabel',
  props: {
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
